import { render, staticRenderFns } from "./serviceInfo.vue?vue&type=template&id=455655fe&scoped=true&"
import script from "./serviceInfo.vue?vue&type=script&lang=js&"
export * from "./serviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455655fe",
  null
  
)

export default component.exports